import axios from 'axios';
import {
	setUser,
	setLoading,
	setError,
	setOrganization,
} from '../features/common/headerSlice';
import store from './store';

const checkAuth = () => {
	const TOKEN = localStorage.getItem('tokenV2');
	const PUBLIC_ROUTES = [
		'login',
		'activate-account',
		'forgot-password',
		'reset-password',
		'registration',
		'signup'
	];

	const isPublicPage = PUBLIC_ROUTES.some((r) => {
		return window.location.href.includes(r);
	});

	if (!TOKEN && !isPublicPage) {
		window.location.href = '/login';
		return;
	}

	// Set the base URL based on the current window location
	if (import.meta.env.VITE_API_ENVIRONMENT === 'local') {
		axios.defaults.baseURL = `http://${import.meta.env.VITE_API_URL}`;
	} else {
		const apiUrl = import.meta.env.VITE_API_URL;
		const urlSuffix = window.location.hostname.endsWith('.app')
			? '.app'
			: '.com';
		axios.defaults.baseURL = `https://${apiUrl.replace(/\.com$/, urlSuffix)}`;
	}

	axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`;

	axios.interceptors.request.use(
		function (config) {
			const whiteList = [
				new RegExp(/^\/api\/chatGroupsMessage\/\d+$/),
				new RegExp(/^\/api\/notifications\?user=\d+$/),
				new RegExp(/^\/api\/chats\/\d+$/),
				new RegExp(/^\/api\/upload\/chunk$/),
				new RegExp(/^\/api\/upload$/),
				new RegExp(/^\/api\/settings$/),
				new RegExp(/^\/api\/workoutreader$/),
				new RegExp(/^\/api\/reporting\/organization\/([^/]+)\/llm$/)
			];

			let showLoadingModal = true;
			for (const rgx of whiteList) {
				if (rgx.test(config.url)) {
					showLoadingModal = false;
					break;
				}
			}
			if (showLoadingModal) {
				document.body.classList.add('loading-indicator');
			}

			return config;
		},
		function (error) {
			return Promise.reject(error);
		}
	);

	axios.interceptors.response.use(
		function (response) {
			// Hide global loading indicator
			document.body.classList.remove('loading-indicator');
			return response;
		},
		function (error) {
			document.body.classList.remove('loading-indicator');

			// TODO: redirect and show error
			return Promise.reject(error);
		}
	);

	if (TOKEN) {
		// Changed from TOKEN !== "" to TOKEN for better truthy check
		// Set loading state to true
		store.dispatch(setLoading(true));

		// Validate token
		axios
			.get(`/api/me`)
			.then((res) => {
				if (res.data.user?.status !== 'approved') {
					// Account is locked
					localStorage.setItem('tokenV2', '');

					store.dispatch(
						setUser({
							user: null,
						})
					);

					store.dispatch(
						setOrganization({
							organization: null,
						})
					);

					window.location.href = '/login?account=locked';
					return;
				}
				store.dispatch(
					setUser({
						user: res.data.user,
					})
				);

				store.dispatch(
					setOrganization({
						organization: res.data.organization,
					})
				);
				store.dispatch(setLoading(false));
				return TOKEN;
			})
			.catch((err) => {
				console.error(err);
				localStorage.setItem('error', err);
				store.dispatch(setError('Authentication failed.'));
				localStorage.setItem('tokenV2', '');
				window.location.href = '/login?status=authfailed';
				return;
			});
	} else {
		// If no token and it's a public page, set loading to false
		store.dispatch(setLoading(false));
	}
};

export default checkAuth;
